<template>
  <Head title="Password zurücksetzen"/>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
    <div class="flex flex-col justify-center items-center">
      <div class="login-card  p-6">
        <div class="w-full max-w-md">
          <logo class="block mx-auto w-full login-card__brand fill-white" height="50"/>
          <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="reset">
            <div class="px-10 py-12">
              <h1 class="text-center text-xl md:text-3xl font-bold">Password zurücksetzen</h1>
              <div class="mt-6 mx-auto w-24 border-b-2"/>
              <text-input v-model="form.email" :error="form.errors.email" class="mt-10" :label="__('general.email')"
                          type="email" autofocus autocapitalize="off"
              />
              <text-input v-model="form.password" :error="form.errors.password" class="mt-6" :label="__('general.password')"
                          type="password"
              />
              <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" :label="__('general.password_confirmation')"
                          type="password"
              />
            </div>
            <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
              <loading-button :loading="form.processing" class="btn-primary ml-auto" type="submit">
                Passwort zurücksetzen
              </loading-button>
            </div>
          </form>
        </div>
      </div>
      <div class="flex justify-center text-sm gap-4">
        <dgvt-legal/>
      </div>
    </div>
  </div>

</template>

<script>

import {Head} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import DgvtLegal from '../../Shared/Navigation/DgvtLegal'

export default {

  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    DgvtLegal
  },

  props: {
    config: Object,
    token: String,
    email: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: this.email,
        token: this.token,
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    reset() {
      console.log("send form")
      this.form.post('/reset', {
        onSuccess: ( response ) => {
          console.log("success")
          console.log( response )
        },
        onError: ( error ) => {
          console.log( "error" )
          // this.showRefresh
        },
      })
    },
  },
}
</script>
